module.exports = __webpack_public_path__ + "static/media/s1-right.5370234b.svg";